<script>
  import { Router, Link, Route } from "svelte-routing";
  import Home from "./routes/Home.svelte";
  import Blog from "./routes/Blog.svelte";
  import Offers from "./routes/Offers.svelte";
  import PricePlot from "./routes/PricePlot.svelte";
  import AvgPricePerDescriptor from "./routes/AvgPricePerDescriptor.svelte";
  import AvgPricePerDescriptorWow from "./routes/AvgPricePerDescriptorWow.svelte";
  import AvgPricePerDescriptorWowTbc from "./routes/AvgPricePerDescriptorWowTbc.svelte";
  import AvgPriceForTop7Wow from "./routes/AvgPriceForTop7Wow.svelte";
  import AvgPerTop3 from "./routes/AvgPerTop3.svelte";
  import Dashboard from "./routes/Dashboard.svelte";
  import Rio from "./routes/Rio.svelte";

  export let env;
  export let url = "";
  export let backend;
  export let frontendVersion;
  let backendVersion = "";
  backend.version().then(v => backendVersion = v)
</script>

<main>
<Router url="{url}">
  <nav class="navbar navbar-expand-lg navbar-dark">
  	<ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <Link class="nav-link" to="/">Home</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="price-plot">График цен</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="dashboard">Дашборд</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="offers">Поиск офферов</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="avgPricePerDescriptor">Средний прайс по дескрипторам</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="avgPricePerDescriptorWow">Средний прайс по дескрипторам Wow retail</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="avgPricePerDescriptorWowTbc">Средний прайс по дескрипторам Wow tbc</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="avgPricePerTop3">Топ3 офферов</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="avgPriceForTop7Wow">Средняя по топ7 Wow retail</Link>
      </li>
      <li class="nav-item">
        <Link class="nav-link" to="rio">Rio</Link>
      </li>
    </ul>
    <div class="ms-auto mr-auto navbar-nav">
    	<div class="nav-item">
    	    <p class="nav-link">backend: {backendVersion}</p>
    	</div>
    	<div class="nav-item">
    	    <p class="nav-link">frontend: {frontendVersion}</p>
    	</div>	
    	<div class="nav-item">
    	    <p class="nav-link">environment: {env.name}</p>
    	</div>
    </div>
    
  </nav>
  <div>
    <Route path="price-plot">
    	<PricePlot backend={backend} />
    </Route>
    <Route path="/">
    	<Home env={env} />
    </Route>
    <Route path="dashboard">
      <Dashboard backend={backend} />
    </Route>
    <Route path="offers">
      <Offers backend={backend} />
    </Route>
    <Route path="avgPricePerDescriptor">
      <AvgPricePerDescriptor backend={backend} />
    </Route>
    <Route path="avgPricePerDescriptorWow">
      <AvgPricePerDescriptorWow backend={backend} />
    </Route>
    <Route path="avgPricePerDescriptorWowTbc">
      <AvgPricePerDescriptorWowTbc backend={backend} />
    </Route>
    <Route path="avgPricePerTop3">
      <AvgPerTop3 backend={backend} />
    </Route>
    <Route path="avgPriceForTop7Wow">
      <AvgPriceForTop7Wow backend={backend} />
    </Route>
    <Route path="rio">
      <Rio backend={backend} />
    </Route>
  </div>
</Router>
</main>
